import request from '@/utils/request'


// 查询敏感词屏蔽列表
export function listProhibitedWord(query) {
  return request({
    url: '/biz/admin/user/prohibited/word/list',
    headers: { 'repeatSubmit': false },
    method: 'post',
    data: query
  })
}

// 查询敏感词屏蔽分页
export function pageProhibitedWord(query) {
  return request({
    url: '/biz/admin/user/prohibited/word/page',
    method: 'post',
    headers: { 'repeatSubmit': false },
    data: query
  })
}

// 查询敏感词屏蔽详细
export function getProhibitedWord(data) {
  return request({
    url: '/biz/admin/user/prohibited/word/detail',
    method: 'get',
    params: data
  })
}

// 新增敏感词屏蔽
export function addProhibitedWord(data) {
  return request({
    url: '/biz/admin/user/prohibited/word/add',
    method: 'post',
    data: data
  })
}

// 修改敏感词屏蔽
export function updateProhibitedWord(data) {
  return request({
    url: '/biz/admin/user/prohibited/word/edit',
    method: 'post',
    data: data
  })
}

// 删除敏感词屏蔽
export function delProhibitedWord(data) {
  return request({
    url: '/biz/admin/user/prohibited/word/delete',
    method: 'post',
    data: data
  })
}
